import { DEFAULT_MAX_ITEMS_PER_TRANSACTION } from '@constants/admissions';
import { Admission } from '@domain/admission';

export const calculateMaxItemsPerTransation = (offerQuantity: number | null) =>
  offerQuantity === null
    ? DEFAULT_MAX_ITEMS_PER_TRANSACTION
    : offerQuantity < DEFAULT_MAX_ITEMS_PER_TRANSACTION
      ? offerQuantity
      : DEFAULT_MAX_ITEMS_PER_TRANSACTION;

export const calculateChannelMaxQuantityPerTransaction = (offer: Admission) => {
  return Math.min(offer.itemsPerTransaction.max ?? 0, offer.availableItems ?? offer.itemsPerTransaction.max) ?? 0;
};
